<div class="meeting-minute-form">
  @if (alertInfo.show) {
    <ngb-alert
      [type]="alertInfo.type"
      (closed)="alertInfo.show = false">
      {{ alertInfo.message }}
    </ngb-alert>
  }

  <form [formGroup]="form">

    <h5 class="meeting-minute-section-title">Meeting</h5>
    <div class="row">
      <div class="col-lg-4 col-md-6">
        <input-field
          label="Subject"
          placeholder="Subject of the meeting"
          [inputFormControl]="getControl('subject')"
          [type]="'text'"
          [readonly]="!canSave">
        </input-field>
      </div>

      <div class="col-lg-2 col-md-6">
        <input-field
          label="Date"
          [inputFormControl]="getControl('date')"
          [type]="'date'"
          [readonly]="!canSave">
        </input-field>
      </div>

      <div class="col-lg-2 col-md-6">
        <input-field
          label="Start time"
          [inputFormControl]="getControl('startTime')"
          [type]="'time'"
          [readonly]="!canSave">
        </input-field>
      </div>

      <div class="col-lg-2 col-md-6">
        <input-field
          label="End time"
          [inputFormControl]="getControl('endTime')"
          [type]="'time'"
          [readonly]="!canSave">
        </input-field>
      </div>

      <div class="col-lg-2 col-md-6">
        <input-field
          label="Reminder"
          [inputFormControl]="getControl('reminder')"
          [type]="'date'"
          [readonly]="!canSave">
        </input-field>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-6">
        <input-field
          label="Place"
          placeholder="Where the meeting took place"
          [inputFormControl]="getControl('place')"
          [type]="'text'"
          [readonly]="!canSave">
        </input-field>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label class="fw-bold meeting-minute-field-label">Department</label>
          <select-field
            [selectFormControl]="getControl('department')"
            [options]="departmentOptions">
          </select-field>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label class="fw-bold meeting-minute-field-label">Written by</label>
          <select-field
            [selectFormControl]="getControl('writtenByUserId')"
            [options]="userOptions">
          </select-field>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="form-group">
          <label class="fw-bold meeting-minute-field-label">Reviewed by</label>
          <select-field
            [selectFormControl]="getControl('reviewedByUserId')"
            [options]="userOptions">
          </select-field>
        </div>
      </div>
    </div>

    <h5 class="meeting-minute-section-title">Topic</h5>
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <input-field
          label="Proposed topic"
          placeholder="The topic proposed for the meeting"
          [inputFormControl]="getControl('proposedTopic')"
          [type]="'text'"
          [readonly]="!canSave">
        </input-field>
      </div>

      <div class="col-lg-8 col-md-12">
        <textarea-field
          label="Development of topic"
          placeholder="How the topic was developed during the meeting"
          [textareaFormControl]="getControl('developmentOfTopic')"
          [readonly]="!canSave"
          [height]="150">
        </textarea-field>
      </div>
    </div>

  </form>

  <div class="meeting-minute-panel">
    <div class="meeting-minute-panel-header">
      <h5 class="meeting-minute-panel-title">Participants</h5>
    </div>
    <div class="meeting-minute-panel-body">
      <meeting-minute-participants
        [rows]="participants"
        [userOptions]="userOptions"
        [statusOptions]="participantStatusOptions"
        [readonlyRows]="!canSave"
        (addRow)="addParticipant()"
        (removeRow)="removeParticipant($event)">
      </meeting-minute-participants>
    </div>
  </div>

  <div class="meeting-minute-panel">
    <div class="meeting-minute-panel-header">
      <h5 class="meeting-minute-panel-title">Actions</h5>
    </div>
    <div class="meeting-minute-panel-body">
      <meeting-minute-actions
        [rows]="actions"
        [userOptions]="userOptions"
        [readonlyRows]="!canSave"
        (addRow)="addAction()"
        (removeRow)="removeAction($event)">
      </meeting-minute-actions>
    </div>
  </div>

  <div class="meeting-minute-panel">
    <div class="meeting-minute-panel-header">
      <h5 class="meeting-minute-panel-title">Agreements</h5>
    </div>
    <div class="meeting-minute-panel-body">
      <meeting-minute-agreements
        [rows]="agreements"
        [readonlyRows]="!canSave"
        (addRow)="addAgreement()"
        (removeRow)="removeAgreement($event)">
      </meeting-minute-agreements>
    </div>
  </div>

  <div class="meeting-minute-panel">
    <div class="meeting-minute-panel-header">
      <h5 class="meeting-minute-panel-title">Risks</h5>
    </div>
    <div class="meeting-minute-panel-body">
      <meeting-minute-risks
        [rows]="risks"
        [userOptions]="userOptions"
        [readonlyRows]="!canSave"
        (addRow)="addRisk()"
        (removeRow)="removeRisk($event)">
      </meeting-minute-risks>
    </div>
  </div>

  <div class="meeting-minute-panel">
    <div class="meeting-minute-panel-header">
      <h5 class="meeting-minute-panel-title">Next meetings</h5>
    </div>
    <div class="meeting-minute-panel-body">
      <meeting-minute-next-meetings
        [rows]="nextMeetings"
        [readonlyRows]="!canSave"
        (addRow)="addNextMeeting()"
        (removeRow)="removeNextMeeting($event)">
      </meeting-minute-next-meetings>
    </div>
  </div>

  @if (canSave) {
    <div class="d-flex justify-content-end align-items-end my-2">
      <button type="button" class="btn btn-success" (click)="submitForm()">Save</button>
    </div>
  }
</div>
